import React from "react";
import { formatDate } from "../../../helper/Helper";
import { Link } from "react-router-dom";

function PurchaseInvoiceRow({
  key,
  index,
  item,
  piStatus,
  page,
  limit,
  onOpen,
}) {
  const statusConfig = piStatus[item.status] || {
    label: item.status,
    color: "secondary",
  };

  return (
    <tr
      key={item.id}
      style={{ cursor: "pointer" }}
      onClick={() => onOpen?.(item.id)}
    >
      <td>
        <code className="fw-semibold">{item.invoiceNumber}</code>
      </td>
      <td className="small">{item.supplierName}</td>
      <td className="small">{item.locationName}</td>
      <td className="small">{formatDate(item.invoiceDate, "D MMM YYYY")}</td>
      <td className="fw-semibold">
        ₹{Number(item.totalAmount).toLocaleString("en-IN")}
      </td>
      <td>
        <span
          className={`badge bg-${statusConfig.color}-subtle text-${statusConfig.color}`}
        >
          {statusConfig.label}
        </span>
      </td>
      <td>
        <span
          className={`badge bg-${item.paymentStatus === "paid" ? "success" : "warning"}-subtle text-${item.paymentStatus === "paid" ? "success" : "warning"}`}
        >
          {item.paymentStatus}
        </span>
      </td>
      <td className="action-table-data">
        <div className="edit-delete-action">
          <Link to={`/purchase-invoices/edit/${item._id}`} className="me-2 p-2">
            <i className="ti ti-pencil" />
          </Link>
        </div>
      </td>
    </tr>
  );
}

export default PurchaseInvoiceRow;
